module.exports = {
  'name': 'null',
  'category': 'Constants',
  'syntax': [
    'null'
  ],
  'description': 'Value null',
  'examples': [
    'null'
  ],
  'seealso': ['true', 'false']
};



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/docs/constants/null.js
// module id = 929
// module chunks = 0